import httpClient from "../httpClient";
import { API_COMMENT_UPDATE } from "../config";

const updateCommentInfo = {
    updateInfo: (id, data) => httpClient.post(API_COMMENT_UPDATE + '/' + id, data),
};

export default updateCommentInfo;
